import { StoreMetadata } from "../types";

export const getLogoFromMetadata = (storeMetadata: StoreMetadata) => {
  return storeMetadata?.profilePicConfiguration?.enableSquare
    ? storeMetadata?.profilePicConfiguration?.squareImage
    : storeMetadata?.profilePicConfiguration?.rectangleImage ||
        storeMetadata?.profilePic;
};
